import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { AddressAddPage } from './address-add.page';
import { BrMaskerModule } from 'brmasker-ionic-3';
import { HttpClientModule } from '@angular/common/http';
import { ErrorService } from 'src/app/services/error/error.service';
import { AddressService } from 'src/app/services/address/address.service';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";

const routes: Routes = [
  {
    path: '',
    component: AddressAddPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    BrMaskerModule,
    HttpClientModule,
    GooglePlaceModule
  ],
  declarations: [AddressAddPage],
  providers: [
    ErrorService,
    AddressService
  ]
})
export class AddressAddPageModule {}
